import {FC, useEffect, useState} from 'react';
import {Box, Typography, Drawer, useMediaQuery} from '@mui/material';
import {DOLLAR, H6, H4} from '@/utils/constants';
import {fund} from './fund.styles';
import Button from '@/shared/components/Button';
import Modal from '@/shared/components/Modal';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import AddDonationModal from '@/components/Organization/TablesAndTickets/AddDonation';
import {getDonationListByEvent, userMakeDonation} from '@/store/user-donation/actions';
import {donationsData, totalDonationsAmount} from '@/store/user-donation/selector';
import FundItem from '@/components/Organization/Fund/FundItem';
import {useSelector} from 'react-redux';
import {getCurrentEventSelector} from '@/store/organization-event';
import {orgAPI} from '@/core/api';
import {usePaymentStatusPolling} from '@/utils/hooks';

const FundTheMission: FC = () => {
	const dispatch = useAppDispatch();
	const currentEvent = useSelector(getCurrentEventSelector);

	const donations = useAppSelector(donationsData);
	const totalAmount = useAppSelector(totalDonationsAmount);

	const [isDonationModalOpen, setIsDonationModalOpen] = useState(false);
	const [value, setValue] = useState('');
	const [bidderId, setBidderId] = useState('');

	const isMobile = useMediaQuery('(max-width:639.98px)');

	const {startPollingFromUrl} = usePaymentStatusPolling({
		onCompleted: () => {
			getDonationsListData();
		},
		apiInstance: orgAPI,
	});

	const getDonationsListData = async () => {
		if (!currentEvent?.id) return;
		try {
			await dispatch(getDonationListByEvent({reqBody: currentEvent.id, apiInstance: orgAPI})).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	const handleMakeDonationModal = () => {
		setIsDonationModalOpen(!isDonationModalOpen);
		setValue('');
		setBidderId('');
	};

	const handleAddDonation = async () => {
		if (!bidderId || !currentEvent) return;

		const reqBody = {
			attendeeId: Number(bidderId),
			amount: Number(value),
			eventId: currentEvent.id,
		};

		try {
			await dispatch(userMakeDonation({reqBody, apiInstance: orgAPI})).unwrap();
			await getDonationsListData();

			toast.success('Donation added successfully');
			setBidderId('');
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		getDonationsListData();
	}, [currentEvent?.id]);

	useEffect(() => {
		startPollingFromUrl();
	}, []);

	return (
		<Box sx={fund.wrapper}>
			<Box sx={{display: 'flex', flexDirection: 'column', flex: 1}}>
				<Box sx={fund.totalWrap}>
					<Typography variant={H6} sx={fund.totalLabel}>
						Total
					</Typography>
					<Typography variant={H4} sx={fund.totalValue}>
						{DOLLAR}
						{totalAmount}
					</Typography>
				</Box>
				<Box sx={fund.fundList}>
					{donations && donations.map((el) => <FundItem key={el.donationId} item={el} />)}

					<Drawer variant="permanent" anchor="bottom" sx={fund.drawer}>
						<Box sx={fund.popup}>
							<Button title="Add Donation" onClick={handleMakeDonationModal} />
						</Box>
					</Drawer>
				</Box>
			</Box>

			<Box sx={fund.button}>
				<Button title="Add Donation" onClick={handleMakeDonationModal} />
			</Box>

			<Modal
				isShowSaveButton={!isMobile}
				mainButtonTitle="Add Donation"
				isShowCloseButton={!isMobile}
				closeButtonTitle="Cancel"
				isSaveButtonDisable={Number(value) <= 0 || Number(bidderId) <= 0}
				onClose={() => {
					setIsDonationModalOpen(false);
				}}
				open={isDonationModalOpen}
				sx={fund.modal}
				onSave={handleAddDonation}
				fullScreen={isMobile}
				hideCloseIcon={isMobile}
			>
				<AddDonationModal
					value={value}
					setValue={setValue}
					bidderId={bidderId}
					setBidderId={setBidderId}
					onClose={handleMakeDonationModal}
					addDonation={handleAddDonation}
				/>
			</Modal>
		</Box>
	);
};

export default FundTheMission;
